module.exports = __webpack_public_path__ + "banner.045cc31c1965fd574184345426d3eb62.png";